<template>
  <v-autocomplete
    v-bind="$attrs"
    v-model="pValue"
    :items="pItems"
    :prepend-icon="parent.icon"
    item-value="id"
    item-text="name"
    clearable
    cache-items
    chips
    color="primary"
    @update:model-value="onUpdate"
  >
    <template #append>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-icon
            class="selector-default-help-icon"
            color="grey"
            size="18"
            v-bind="props"
          >
            mdi-help
          </v-icon>
        </template>
        <span>{{ helpText }}</span>
      </v-tooltip>
    </template>

    <template #chip="{ props, item }">
      <v-chip v-bind="props" :text="item.raw.name">
        <template #prepend>
          <v-icon
            class="mr-2"
            :color="item.raw.color ? item.raw.color : 'primary'"
          >
            {{ item.raw.icon || "mdi-label" }}
          </v-icon>
        </template>
      </v-chip>
    </template>

    <template #item="{ item, props }">
      <v-list-item
        v-bind="props"
        :prepend-icon="item.raw.icon"
        :subtitle="item.raw.name"
        :title="item.raw.iso3"
      />
    </template>
  </v-autocomplete>
</template>
    
    
    <script>
import { AudienceAPIInstance } from "../../../../api";

export default {
  name: "SelectorInterestsCategories",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    helpText: {
      type: String,
      default: "",
    },
    timeout: {
      type: Number,
      default: 400,
    },
    parentId: {
      type: Number,
      default: undefined,
    },
    parent: {
      type: Object,
      default: () => ({}),
    },
    tooltipAttrs: {
      type: Object,
      default: () => ({
        bottom: true,
      }),
    },
    autoload: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onSearch", "update:modelValue"],
  data() {
    return {
      api: AudienceAPIInstance,
      search: "",
      pTimeout: undefined,
      pItems: this.data,
      pValue: this.modelValue.filter((item) => item.parentId === this.parentId),

      // Autoload
      pagination: {
        page: 1,
        pageSize: 100,
      },
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.pValue = newValue.filter(
          (item) => item.parent_category_id === this.parentId
        );
      },
    },
  },
  mounted() {
    if (this.autoload) this.getList();
  },

  methods: {
    onUpdate(newValue) {
      const valuesFromAnotherParent = this.modelValue.filter(
        (item) => item.parent_category_id !== this.parentId
      );

      this.$emit("update:modelValue", [
        ...valuesFromAnotherParent,
        ...newValue,
      ]);
    },
    async getList(search) {
      if (!this.parentId) return;

      const { pagination, items } = await this.api.interests(
        this.parentId,
        this.pagination,
        {
          search: search ? search : this.search,
        }
      );

      this.pagination = pagination;
      this.pItems = items;
    },
  },
};
</script>
    
    
    <style lang="scss" scoped>
.v-input__control {
  div {
    background: transparent !important;
  }
}
.v-input__slot {
  background: transparent;
}

.selection {
  margin-top: 4px;
  margin-left: 4px;
}
</style>